import { BallotCandidate } from "../types";
import Modal from "./Modal";

/**
 * Venues (Google Places) embed cleanly via the keyless Maps embed; event pages
 * (Ticketmaster/Search) often refuse framing, so we still offer "Open in new tab".
 */
const embedSrc = (c: BallotCandidate): string | null => {
  if (c.source === "GooglePlaces" && c.latitude != null && c.longitude != null) {
    return `https://maps.google.com/maps?q=${c.latitude},${c.longitude}&z=15&output=embed`;
  }
  return c.url ?? null;
};

const EventDetailsModal: React.FC<{ candidate: BallotCandidate | null; onClose: () => void }> = ({
  candidate,
  onClose,
}) => {
  const src = candidate ? embedSrc(candidate) : null;
  return (
    <Modal open={!!candidate} onClose={onClose} title={candidate?.title ?? "Details"}>
      {candidate && (
        <div>
          {candidate.description && <p className="text-sm text-ink/70">{candidate.description}</p>}
          {src ? (
            <iframe
              title={candidate.title}
              src={src}
              loading="lazy"
              className="mt-3 h-72 w-full rounded-xl border border-primary-100"
            />
          ) : (
            <p className="mt-3 text-sm text-ink/55">No preview available.</p>
          )}
          {candidate.url && (
            <a
              href={candidate.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-block text-sm font-medium text-dusk-500 hover:text-dusk-700"
            >
              Open in new tab ↗
            </a>
          )}
        </div>
      )}
    </Modal>
  );
};

export default EventDetailsModal;
